import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "archive-preview" };
const _hoisted_2 = { class: "view-all" };
import { ref, onMounted } from 'vue';
import { getArchivePreview } from '@/api/page';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArchivePreview',
    setup(__props) {
        /**
         * 归档预览组件
         * 在首页侧边栏展示按年份归档
         */
        const archive = ref([]);
        onMounted(async () => {
            archive.value = await getArchivePreview();
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(archive.value, (group) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: group.year
                        }, [
                            _createVNode(_component_router_link, { to: "/archive" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(group.year) + " (" + _toDisplayString(group.count) + ") ", 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, { to: "/archive" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode("查看完整归档 →", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
